<template>
    <div class="row rowBorder">
        <div class="col-6 col-sm-8 col-md-8 border-right">
            <div class="row">
                <div class="col-12 col-sm-5 col-md-5 pr-0 pl-4 pt-2 pb-1 selection" v-for="size in sizes" :key="size.size">
                    <div @click="searchByMaxStklId(size.maxstklId)">
                        <h4>{{$t('tree-children.size')}} {{size.size}}</h4>
                        <span>{{size.maxDrehmoment}}</span><br>
                        <span>{{size.maxRPM}}</span><br>
                        <span>∅ {{size.durchmesser}}</span><br>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-4 col-md-4 pt-2">
            <h6>{{$t('product-sizes.diskPack' + lamellenpaket)}}</h6>
            <p class="mb-1">{{$t('product-sizes.diskpack' + lamellenpaket + 'Nm')}}</p>
            <p class="mb-1">{{$t('product-sizes.diskpack' + lamellenpaket + 'Winkel')}}</p>
        </div>
    </div>
</template>

<script>
    import searchByMaxStklId from '../../mixins/searchByMaxStklId';

    export default {
        name: "ProductSizesRows",
        props: ['sizes', 'lamellenpaket'],
        mixins: [searchByMaxStklId]
    }
</script>

<style scoped>
    .rowBorder {
       align-items: center;
       border-left: 1px solid #dee2e6;
       border-right: 1px solid #dee2e6;
       border-bottom: 1px solid #dee2e6;
       margin: 0px;
    }

    .selection {cursor: pointer;}
</style>